import React, { createContext, useContext, useEffect } from 'react';

import { useLocalStorage } from '../useLocalStorage';

const CurrentAccountIdContext = createContext(undefined);

export const useCurrentAccountId = () => useContext(CurrentAccountIdContext);

type Props = {
  /**
   * Provide a `currentAccountId` to set its value,
   * which is typically provided by the router.
   */
  currentAccountId?: number;
  children: React.ReactNode;
};

export const CurrentAccountIdProvider = (props: Props) => {
  const [currentAccountId, setCurrentAccountId] = useLocalStorage(
    'currentAccountId'
  );
  useEffect(() => {
    if (props.currentAccountId && currentAccountId !== props.currentAccountId) {
      setCurrentAccountId(props.currentAccountId);
    }
  }, [props.currentAccountId, currentAccountId, setCurrentAccountId]);
  return (
    <CurrentAccountIdContext.Provider value={currentAccountId}>
      {props.children}
    </CurrentAccountIdContext.Provider>
  );
};
